export default "/images/devices.jpg?1c013a95e898c7bba9b18f6d16576222";